export default class InvoiceOcr {
  public enabled: boolean
  public contents: number
  public type: string
  public fixedLength: number
  public template: string
  public customerNumberFixedLength: number
  public invoiceNumberFixedLength: number

  public constructor(data: Record<string, unknown> = null) {
    if (!data) {
      data = {}
    }
    this.enabled = data.enabled as boolean || false
    this.contents = data.contents != null ? (data.contents as number) : null
    this.type = data.type as string || ''
    this.fixedLength = data.fixedLength as number || null
    this.template = data.template as string || ''
    this.customerNumberFixedLength = data.customerNumberFixedLength as number || null
    this.invoiceNumberFixedLength = data.invoiceNumberFixedLength as number || null
  }

  public clone(): InvoiceOcr {
    const result = new InvoiceOcr()
    Object.assign(result, this)
    return result
  }

  public formToModel(): Record<string, any> {
    return {
      enabled: this.enabled,
      type: this.type,
      contents: this.contents,
      fixedLength: this.fixedLength,
      customerNumberFixedLength: this.customerNumberFixedLength,
      invoiceNumberFixedLength: this.invoiceNumberFixedLength,
      template: this.contents == 3 ? this.template != null ? this.template : ' ' : ' ',
    }
  }
}
